<template>
  <div class="">
    <v-container>
      <front-navigation></front-navigation>
      <br>
      <v-layout row wrap>
        <v-flex lg12 md12 sm12 xs12 v-if="facilityImages.length > 0">
          <carousel :autoplay="true" :autoplayTimeout="3000" :autoplayHoverPause="true" :perPage="1">
            <slide v-for="(image, key) in facilityImages" :key="key">
              <img :src="image.path" width="100%" alt="olpejeta accommodation">
            </slide>
          </carousel>
        </v-flex>
        <v-flex lg12 md12 sm12 xs12 v-else>
          <img :src="singleFacility.thumbnail" alt="olpejeta accommodation">
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex lg6 md6 sm12 xs12>
          <div class="">
            <div class="container">
              <h3 class="earth-color">{{(singleFacility.name).toUpperCase()}}</h3>
              <span style="color: gray; line-height: 1.4444444444444444em !important; font-size: 16px"v-html="singleFacility.description"></span>
            </div>
            <div class="container-fluid" v-if="booking === true">
              <div class="row">
                <div class="col-md-12">
                  <input type="checkbox" class="form-control col-md-2">
                  <label class="col-md-10">Park Fees</label>
                </div>
              </div>
            </div>
          </div>
        </v-flex>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <!--<v-btn slot="activator" color="primary" large dark>BOOK NOW</v-btn>-->
          <v-card>
            <v-card-title>
              <span class="headline">Booking Dates</span>
            </v-card-title>
            <v-tabs
              v-model="active"
              color="primary"
              dark
              slider-color="primary"
            >
              <v-tab :key="1" ripple>Accommodation Availability</v-tab>
              <v-tab-item :key="1">
                <v-card flat>
                  <v-card-text>
                    <v-flex xs12 sm6 md12>
                      <v-dialog
                        ref="dialog3"
                        persistent
                        v-model="modal4"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="facility.start_date"
                      >
                        <v-text-field
                          slot="activator"
                          label="Start Date *"
                          v-model="facility.start_date"
                          readonly
                        ></v-text-field>
                        <v-date-picker
                          v-model="facility.start_date"
                          scrollable
                          :min="a_start_date"
                        >
                          <v-spacer></v-spacer>
                          <v-btn :depressed="true" flat color="primary" @click="modal4 = false">Cancel</v-btn>
                          <v-btn :depressed="true" flat color="primary" @click="$refs.dialog3.save(facility.start_date)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                    <v-flex xs12 sm6 md12>
                      <v-dialog
                        ref="dialog4"
                        persistent
                        v-model="modal3"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="facility.end_date"
                      >
                        <v-text-field
                          slot="activator"
                          label="End Date *"
                          v-model="facility.end_date"
                          readonly
                          id="activity_date"
                        ></v-text-field>
                        <v-date-picker
                          v-model="facility.end_date"
                          scrollable
                          :min="facility.start_date"
                          @input="searchFacilityAvailability()"
                        >
                          <v-spacer></v-spacer>
                          <v-btn :depressed="true" flat color="primary" @click="modal3 = false">Cancel</v-btn>
                          <v-btn :depressed="true" flat color="primary" @click="$refs.dialog4.save(facility.end_date)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                    <div class="row">
                      <v-flex xs6 sm12 md12 v-if="showDates = true">
                        <v-container>
                          <v-autocomplete
                            label="Children"
                            :onClick="childSlots"
                            :items="childSlots"
                            v-model="facility.children"
                            v-bind:disabled="facility.end_date.length === 0 ? true : false"
                          ></v-autocomplete>
                        </v-container>
                      </v-flex>
                      <v-flex xs6 sm12 md12 v-if="showDates = true">
                        <v-container>
                          <v-autocomplete
                            label="Adults"
                            :onClick="adultSlots"
                            :items="adultSlots"
                            v-model="facility.adults"
                            v-bind:disabled="facility.end_date.length === 0 ? true : false"
                          ></v-autocomplete>
                        </v-container>
                      </v-flex>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-tab-item>
              <v-tab  :key="2" ripple>Conservation Fees</v-tab>
              <v-tab-item :key="2">
                <v-card-text>
                  <div class="row">
                  </div>
                  <v-flex xs12 sm6 md12>
                    <v-container>
                      <v-dialog
                        ref="dialog"
                        persistent
                        v-model="modal1"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="facility.check_in"
                      >
                        <v-text-field
                          slot="activator"
                          label="Check-in *"
                          v-model="facility.check_in"
                          readonly
                          v-bind:disabled="facility.end_date.length === 0 ? true : false"
                        ></v-text-field>
                        <v-date-picker
                          v-model="facility.check_in"
                          :min="facility.start_date"
                          scrollable>
                          <v-spacer></v-spacer>
                          <v-btn :depressed="true" flat color="primary" @click="modal1 = false">Cancel</v-btn>
                          <v-btn :depressed="true" flat color="primary" @click="$refs.dialog.save(facility.check_in)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-container>
                  </v-flex>
                  <v-flex xs12 sm6 md12>
                    <v-container>
                      <br>
                      <v-dialog
                        ref="dialog1"
                        persistent
                        v-model="modal2"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="facility.check_out"
                      >
                        <v-text-field
                          slot="activator"
                          label="Check-out *"
                          v-model="facility.check_out"
                          readonly
                          v-bind:disabled="facility.end_date.length === 0 ? true : false"
                        ></v-text-field>
                        <v-date-picker
                          v-model="facility.check_out"
                          :min="facility.check_in"
                          scrollable>
                          <v-spacer></v-spacer>
                          <v-btn :depressed="true" flat color="primary" @click="modal2 = false">Cancel</v-btn>
                          <v-btn :depressed="true" flat color="primary" @click="$refs.dialog1.save(facility.check_out)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                      <v-flex lg12 md12 sm12>
                        <v-container>
                          Conservation entry fees
                          <guests></guests>
                        </v-container>
                      </v-flex>
                      <v-flex lg12 md12 sm12>
                        <v-container>
                          Vehicle entry fees
                          <vehicle/>
                        </v-container>
                      </v-flex>
                    </v-container>
                  </v-flex>
                  <small>*indicates required field</small>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary darken-1" flat @click="addAccommodation()">Make A Reservation</v-btn>
                </v-card-actions>
              </v-tab-item>
            </v-tabs>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" flat @click="dialog = false">Close</v-btn>
              <!--<v-btn color="primary darken-1" flat @click="checkAvailability() && loadingdialog_ === true" v-if="continue_ === false">{{availabilityButton}}</v-btn>-->
              <!--<v-btn color="primary darken-1" flat @click="makeReservation()" v-if="continue_ === true">{{bookButton}}</v-btn>-->
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
    {{bookingStatus}}
  </div>
</template>

<script>
import FrontNavigation from './../Repeated/FrontNavigation'
import SideBar from '../Repeated/SideBar'
import Guests from '../Repeated/Guests'
import Vehicle from '../Repeated/Vehicle'

export default {
  data () {
    return {
      booking: false,
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      a_start_date: this.$moment().format('YYYY-MM-DD'),
      adjust: false,
      switch1: true,
      dialog: false,
      dialog4: false,
      modal3: false,
      modal4: false,
      dialog3: false,
      continue_: false,
      showDates: false,
      loadingdialog_: false,
      totalCount: 0,
      facility: {
        start_date: '',
        end_date: '',
        days: 0,
        check_in: '',
        check_out: '',
        currency: localStorage.getItem('currency'),
        activity_date: '',
        children: 0,
        adults: 0,
        catering_type: '',
        accommodation: {}
      }
    }
  },
  beforeCreate () {
    this.$store.dispatch('get_facility', this.$route.params.facility_id)
    this.$store.dispatch('get_facility_images', this.$route.params.facility_id)
  },
  updated () {
    window.dataLayer = window.dataLayer || []
    var lc = document.createElement('script'); lc.type = 'text/javascript'; lc.async = true
    lc.src = ('https:' == document.location.protocol ? 'https://' : 'http://' + 'www.googletagmanager.com/gtag/js?id=AW-942857980')
    function gtag (){ dataLayer.push(arguments) }
    if (this.singleFacility.length > 0) {
      this.$ga.event(this.singleFacility.google_analytics_code)
      gtag('event', 'conversion', { 'send_to': this.singleFacility.google_analytics_code })
      // FaceBook Pixel Integration
      this.$analytics.fbq.init('429186911200180', {
        em: 'victor.kasii@olpejetaconservancy.org'
      })
      this.$analytics.fbq.event('View Accommodation', {
        content_name: this.singleFacility.name
      })
    } else {
      this.$ga.event(this.singleFacility.google_analytics_code)
      this.$ga.page(this.singleFacility.google_analytics_code)
      gtag('event', 'conversion', { 'send_to': this.singleFacility.google_analytics_code })
      // FaceBook Pixel Integration
      this.$analytics.fbq.init('429186911200180', {
        em: 'victor.kasii@olpejetaconservancy.org'
      })
      this.$analytics.fbq.event('View Accommodation', {
        content_name: this.singleFacility.name
      })
    }
  },
  computed: {
    childSlots () {
      var slots = []
      var available = this.calculateChildMax
      for (var i = 0; i <= available; i++) {
        slots.push(i)
      }
      return slots
    },
    adultSlots () {
      var slots = []
      var available = this.calculateAdultMax
      for (var i = 0; i <= available; i++) {
        slots.push(i)
      }
      return slots
    },
    cateringType () {
      var normalPricing = []
      var length = this.$allPricingGroups.length
      for (var i = 0; i < length; i++) {
        if (i < 3) {
          normalPricing.push(this.$allPricingGroups[i])
        }
      }
      var route = this.$route.name
      if (route === 'NewBooking' || route === 'EditBooking') {
        return this.$allPricingGroups
      } else {
        return normalPricing
      }
    },
    currency: function () {
      return this.$store.state.CurrencyStore.browser_currency
    },
    facilitySlots: function () {
      var slots = Number(this.singleFacility.maximum_guests) - Number(this.total)
      if (isNaN(slots) === true) {
        return 0
      } else {
        return slots
      }
    },
    calculateAdultMax: function () {
      return (Number(this.singleFacility.maximum_guests) - Number(this.total)) + this.facility.adults
    },
    calculateChildMax: function () {
      return (Number(this.singleFacility.maximum_guests) - Number(this.total)) + this.facility.children
    },
    total: function () {
      return Number(this.facility.adults) + Number(this.facility.children)
    }
  },
  methods: {
    searchFacilityAvailability: function () {
      var data = {
        check_in_date: this.facility.start_date,
        check_out_date: this.facility.end_date
      }
      this.$store.dispatch('check_date_facility_availability', data)
      this.$store.dispatch('get_facility', this.$route.params.facility_id)
    },
    addAccommodation: function () {
      var facility = this.$store.state.FacilityStore.facility
     
      if (facility.pricing_status === 'false') {
        alert('No pricing has been set for this period')
      } else if (facility.accomodation_type_id === 'Pelican' && this.facility.catering_type !== '9a9a77eb' && this.facility.catering_type !== '266677c3' && facility.group_pricing_status === 'false') {
        alert('No special Pricing available for the selected Accommodation')
      } else {
        var data = {
          public_id: facility.public_id,
          catering_type: this.facility.catering_type,
          facility_type: facility.facility_type_id,
          accommodation_type: facility.accomodation_type_id,
          start_date: this.facility.start_date,
          end_date: this.facility.end_date,
          name: facility.name,
          children: this.facility.children,
          adults: this.facility.adults,
          discounts: facility.discount,
          discount_status: facility.discount_status
        }
        if (facility.accomodation_type_id === 'Pelican') {
          var priceIndex
          var currencyList = []
          if (this.facility.catering_type === '9a9a77eb') {
           
            facility.price.map(function (item, index) {
              if (item.hasOwnProperty('lower_limit_list') && item.lower_limit_list.length > 0) {
                priceIndex = index
                currencyList = item.upper_currency
              }
            })
          } else if (this.facility.catering_type === '266677c3') {
            
            facility.price.map(function (item, index) {
              if (item.hasOwnProperty('upper_upper_limit_list') && item.upper_upper_limit_list.length > 0) {
                priceIndex = index
                currencyList = item.lower_currency
              }
            })
          }
          var pelicanPricing = {
            pack_prices: facility.price[priceIndex],
            pack_currency: facility.price[priceIndex],
            pelican_lower_currency: currencyList
          }
          Object.assign(data, pelicanPricing)
        } else if (facility.accomodation_type_id === 'Stables') {
          switch (facility.quantity) {
            case '1':
            
              var SingleRoomPricing = {
                quantity: facility.quantity,
                child_price: facility.price[0].child_price,
                mandatory_price: facility.price[0].mandatory_price,
                currency: facility.price[0].currency_type,
                adult_price: facility.price[0].mandatory_price * this.facility.adults
              }
              Object.assign(data, SingleRoomPricing)
              break
            default:
              
              var _nonPelicanPricing = {
                adult_price: facility.price[0].adult_price,
                child_price: facility.price[0].child_price,
                mandatory_price: facility.price[0].mandatory_price,
                currency: facility.price[0].currency_type
              }
              Object.assign(data, _nonPelicanPricing)
          }
        } else {
          var nonPelicanPricing = {
            adult_price: facility.price[0].adult_price,
            child_price: facility.price[0].child_price,
            mandatory_price: facility.price[0].mandatory_price,
            currency: facility.price[0].currency_type
          }
          Object.assign(data, nonPelicanPricing)
        }
        if (facility.group_pricing_status === 'true' && this.facility.catering_type !== '9a9a77eb' && this.facility.catering_type !== '266677c3') {
          var extraData = {
            extra_price: facility.group_price[this.findGroup(facility)].extra_price,
            special_mandatory_price: facility.group_price[this.findGroup(facility)].mandatory_price,
            special_currency: facility.group_price[this.findGroup(facility)].currency_type,
            from_number: facility.group_price[this.findGroup(facility)].from_number,
            to_number: facility.group_price[this.findGroup(facility)].to_number,
            maximum_number: facility.group_price[this.findGroup(facility)].maximum_number
          }
          Object.assign(data, extraData)
        }
        var oldData = JSON.parse(localStorage.getItem('facility_data'))
        this.$store.commit('BROWSER_FACILITIES', oldData)
        this.$store.commit('ADD_FACILITY', data)
        localStorage.setItem('facility_data', JSON.stringify(this.chosenFacilities))
        this.$router.push({
          name: 'Reservation'
        })
      }
    }
  },
  components: {
    SideBar,
    FrontNavigation,
    Guests,
    Vehicle
  }
}
</script>

<style>
  .main-image {
    max-height: 100%;
    max-width: 100%;
  }
  #side {
    /*z-index: 100;*/
    /*margin-top: -10%;*/
    /*position: absolute;*/
    /**/
    background-color: white;
  }
</style>
